import React, { FC } from 'react';
import { SocialNetwork } from 'types/socialNetwork';
import { SocialNetworkIcon } from './SocialNetworkIcon';
import Grid from '@material-ui/core/Grid';
import { Pad } from 'styles/Pad';
import { makeStyles } from '@material-ui/core';

export const SocialNetworks: FC<{
  networks: SocialNetwork[];
  color: string;
}> = ({ networks, color }) => {
  const classes = useStyles();
  return (
    <Pad>
      <Grid className={classes.socialNetworksContainer} container>
        {networks.map(network => {
          return (
            <Grid item xs={2} className={classes.gridItem}>
              <SocialNetworkIcon network={network} color={color} />
            </Grid>
          );
        })}
      </Grid>
    </Pad>
  );
};

const useStyles = makeStyles({
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  socialNetworksContainer: {
    justifyContent: 'space-around',
    maxWidth: '400px',
    width: '100%',
    rowGap: '10px'
  }
});
